export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_PENDING = 'PAYMENT_PENDING';
export const FULL_PAYMENT = 'FULL_PAYMENT';

export const COMMUNITY_ONE_TIME_PAYMENT_ENTITIES = Object.freeze({
  EVENT: 'community_events',
  FOLDER: 'community_folders',
});
